import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useParams, useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { toast } from 'react-toastify';

// @mui
import { styled } from '@mui/material/styles';
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Snackbar,
  Alert,
  Container,
  Typography,
  Card,
  CardActions,
  Button,
  CardContent,
  Grid,
} from '@mui/material';

import { postReq, getReq, patchReq, deleteRequest } from '../../data/ApiReq';

// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import ApiUrl from '../../data/ApiUrl';
import Loading from '../../components/loading';

const queryString = require('query-string');

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function AddLocation() {
  const initialState = {
    office: '',
    address: '',
    lat: '',
    lng: '',
    type: 'new',
  };
  const initialResult = {
    error: false,
    message: '',
    alert: false,
    loading: false,
    dataFetched: false,
    redirect: false,
  };
  const params = useParams();
  const { userId } = useParams();
  const location = useLocation();
  const [data, setData] = useState('');
  const [state, setState] = useState(initialState);
  const [apiResult, setApiResult] = useState(initialResult);
  const [locationList, setLocationList] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const getData = async () => {
    if (!params.id) {
      return;
    }

    setLoading(true);

    // const query = queryString.parse(location.search);
    // console.log('Location', query);

    const response = await getReq({ url: `/location/${params.id}` });

    // console.log(response.data);

    if (response.data) {
      const { data } = response;

      setState({
        ...state,
        office: data.office,
        address: data.address,
        lat: data?.location?.coordinates[1],
        lng: data?.location?.coordinates[0],
        attendenceDevice: data?.attendenceDevice,
        attendenceDeviceSN: data?.attendenceDeviceSN,
        type: 'edit',
      });
    }

    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const createLocation = async (e) => {
    setLoading(true);

    setApiResult({ ...apiResult, loading: true, alert: true });
    e.preventDefault();
    const data = {
      office: state.office,
    };
    // if (state.brandDesc) {
    //   data.brandDesc = state.brandDesc;
    // } else {
    //   data.brandDesc = `${state.brandName} Products `;
    // }
    if (state.address) data.address = state.address;
    if (state.lat) data.lat = state.lat.toString();
    if (state.lng) data.lng = state.lng.toString();
    if (state.attendenceDevice) data.attendenceDevice = state.attendenceDevice;

    if (state.attendenceDeviceSN) data.attendenceDeviceSN = state.attendenceDeviceSN;
    const response = await postReq({
      url: '/location/submit',
      data,
    });

    if (!response.error) {
      setState(initialState);
      setApiResult({
        ...apiResult,
        error: false,
        message: response.data.message,
        alert: true,
        loading: false,
      });
      toast.success(response.message);
    } else {
      // console.log(response?.message);
      setApiResult({
        ...apiResult,
        error: true,
        message: response?.message,
        alert: true,
        loading: false,
      });
      toast.error(response?.message);
    }
    setTimeout(() => {
      setApiResult({ ...apiResult, alert: false });
      // window.location.reload(false);
    }, 3000);

    setLoading(false);
  };

  const { id } = useParams();
  // data.id = userId;

  const updateLocation = async (e) => {
    setLoading(true);

    setApiResult({ ...apiResult, loading: true });
    e.preventDefault();
    const data = { locationId: params.id };
    if (state.office) data.office = state.office;

    if (state.address) data.address = state.address;

    if (state.lat) data.lat = state.lat.toString();

    if (state.lng) data.lng = state.lng.toString();

    if (state.attendenceDevice) data.attendenceDevice = state.attendenceDevice;

    if (state.attendenceDeviceSN) data.attendenceDeviceSN = state.attendenceDeviceSN;

    // only for making slug remove this
    data.slug = state.office;

    const response = await patchReq({
      url: `/location/respond/${id}`,
      data,
    });

    if (!response.error) {
      setApiResult({
        ...apiResult,
        error: false,
        message: response.data.message,
        alert: true,
        loading: false,
      });
      toast.success(response.message);
    } else {
      setApiResult({
        ...apiResult,
        error: true,
        message: response.data.message,
        alert: true,
        loading: false,
      });
      toast.error(response.message);
    }
    setTimeout(() => {
      setApiResult({ ...apiResult, alert: false });
      setState(initialState);
    }, 3000);

    setLoading(false);
  };

  const deleteLocation = async (e) => {
    setLoading(true);

    setApiResult({ ...apiResult, loading: true });
    e.preventDefault();
    const response = await deleteRequest({ url: `/location/delete?id=${params.id}` });
    // console.log('id--', params.id);
    if (!response.error) {
      toast.success(response.data.message);
      setApiResult({ redirect: true });
    } else {
      toast.error(response.data.message);
      setApiResult({
        ...apiResult,
        error: true,
        alert: true,
        message: response.data.message,
        loading: false,
      });
    }
    setTimeout(() => {
      setApiResult({ ...apiResult, alert: false });
    }, 3000);

    setLoading(false);
  };

  const LocationSchema = Yup.object().shape({
    office: Yup.string().min(3, 'Please enter Office').required('Office is required'),
    address: Yup.string().min(3, 'Please enter Address').required('Address is required'),
    // date: Yup.date('Please enter valid date').required('Date is required'),
  });

  const formik = useFormik({
    initialValues: state,
    enableReinitialize: true,
    validationSchema: LocationSchema,
    // onChange: (e) => {
    //   console.log(e);
    // },
    onSubmit: (values, { resetForm }) => {
      // console.log(values);

      updateLocation(values, resetForm);
    },
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  if (loading) {
    return (
      <Page title="Add Location">
        <Loading />
      </Page>
    );
  }

  return (
    <Page title="Add Location">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography
            variant="h4"
            gutterBottom
            sm="4"
            title={params.id ? 'Edit Location' : 'Add Location'}
            subtitle=" "
            className="text-sm-left"
          >
            {params.id ? 'Edit Location' : 'Add Location'}
          </Typography>

          <Button
            variant="text"
            component={RouterLink}
            to={`/dashboard/settings/getalllocation`}
            startIcon={<Iconify icon={'material-symbols:arrow-back-rounded'} />}
            color={'primary'}
          >
            Location List
          </Button>
        </Stack>
        <Grid container spacing={0} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={7}>
            <Card>
              <CardContent>
                <div>
                  <FormikProvider>
                    {/* <Form autoComplete="off" noValidate > */}
                    <Stack spacing={3}>
                      <Typography variant="h5" gutterBottom>
                        Basic Details
                      </Typography>

                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <Stack spacing={2} style={{ width: '100%', marginBottom: '10px' }}>
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            label="Office"
                            {...getFieldProps('office')}
                            error={Boolean(touched.office && errors.office)}
                            helperText={touched.office && errors.office}
                            onChange={handleChange}
                          />
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            label="Address"
                            {...getFieldProps('address')}
                            error={Boolean(touched.address && errors.address)}
                            helperText={touched.address && errors.address}
                            onChange={handleChange}
                          />
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            label="Latitude"
                            {...getFieldProps('lat')}
                            error={Boolean(touched.lat && errors.lat)}
                            helperText={touched.lat && errors.lat}
                            onChange={handleChange}
                            type={'number'}
                          />
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            type={'number'}
                            label="Longitude"
                            {...getFieldProps('lng')}
                            error={Boolean(touched.lng && errors.lng)}
                            helperText={touched.lng && errors.lng}
                            onChange={handleChange}
                          />

                          <h5>Configure Attendence Device</h5>
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            label="Attendence Device"
                            {...getFieldProps('attendenceDevice')}
                            onChange={handleChange}
                          />

                          <TextField
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            label="Attendence Device Serial Number"
                            {...getFieldProps('attendenceDeviceSN')}
                            onChange={handleChange}
                          />
                        </Stack>
                      </Stack>
                    </Stack>
                    {state.type === 'new' ? (
                      <Button
                        className=" brand-buttons"
                        fullWidth
                        size="large"
                        variant="contained"
                        color="primary"
                        onClick={createLocation}
                        style={{ marginTop: '10px' }}
                      >
                        Submit
                      </Button>
                    ) : (
                      <>
                        {/* <Button onClick={deleteLocation} color="error" className="brand-buttons" variant="contained">
                          Delete
                        </Button> */}
                        <Button
                          onClick={updateLocation}
                          color="warning"
                          className="mr-4 brand-buttons"
                          variant="contained"
                          size="large"
                          fullWidth
                        >
                          Update
                        </Button>
                      </>
                    )}
                    {/* </Form> */}
                  </FormikProvider>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
